import RecommendParallelTodosButton from './recommend-parallel-todos';
import RecommendNextTodosButton from './recommend-next-todos';
import RecommendEasyTodosButton from './recommend-easy-todos';
import RecommendOptionalTodosButton from './recommend-optional-todos';
import RecommendDelegateTodosButton from './recommend-delegate-todos';

const TodayAIActions = () => {
    return (
        <div className="text-sm my-2 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-2">
            <RecommendNextTodosButton />
            <RecommendParallelTodosButton />
            <RecommendEasyTodosButton />
            <RecommendOptionalTodosButton />
            <RecommendDelegateTodosButton />
        </div>
    )
};

export default TodayAIActions;